import type { IconProps } from "@/components/ui/icons/icon-base"

const box = (size: number, width: number, height: number, props: IconProps) => ({
  width: (size * width) / height,
  height: size,
  viewBox: `0 0 ${width} ${height}`,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  ...props,
})

const STAR_PATH =
  "M7.45211 0.277359L9.53393 4.40218L13.5408 4.79917C13.6362 4.8071 13.7273 4.84219 13.8034 4.9003C13.8794 4.95841 13.9373 5.03711 13.97 5.12706C14.0027 5.21701 14.009 5.31447 13.9881 5.40788C13.9671 5.50128 13.9199 5.58674 13.8519 5.65412L10.5543 8.92275L11.7769 13.3643C11.8019 13.4585 11.7992 13.5579 11.769 13.6506C11.7389 13.7433 11.6826 13.8253 11.607 13.8868C11.5313 13.9482 11.4395 13.9865 11.3426 13.997C11.2457 14.0076 11.1478 13.9899 11.0608 13.9461L6.99853 11.9344L2.94189 13.9436C2.85482 13.9874 2.75695 14.0051 2.66005 13.9946C2.56316 13.984 2.47136 13.9457 2.39572 13.8843C2.32007 13.8228 2.26378 13.7408 2.23363 13.6481C2.20348 13.5554 2.20075 13.456 2.22576 13.3618L3.44835 8.92026L0.148288 5.65164C0.0803033 5.58425 0.0330489 5.4988 0.0121198 5.40539C-0.0088093 5.31198 -0.00253666 5.21453 0.0301951 5.12457C0.0629268 5.03462 0.120747 4.95593 0.196809 4.89781C0.272872 4.8397 0.363992 4.80461 0.45938 4.79668L4.46625 4.39969L6.54496 0.277359C6.58771 0.193855 6.65268 0.123773 6.73271 0.0748343C6.81274 0.0258958 6.90473 0 6.99853 0C7.09234 0 7.18432 0.0258958 7.26435 0.0748343C7.34439 0.123773 7.40936 0.193855 7.45211 0.277359Z"

const STAR_OUTLINE_PATH =
  "M8.86426 4.74023C8.97987 4.96925 9.20467 5.12313 9.45996 5.14844L12.9473 5.49414L10.0264 8.38965C9.83393 8.5804 9.75914 8.86083 9.83105 9.12207L10.9072 13.0332L7.33105 11.2627C7.14757 11.1719 6.93655 11.1604 6.74609 11.2285L6.66602 11.2627L3.09473 13.0303L4.17188 9.11914C4.24365 8.85804 4.16881 8.57837 3.97656 8.3877L1.05176 5.49121L4.54004 5.14648C4.79546 5.12118 5.02017 4.96648 5.13574 4.7373L6.99805 1.04297L8.86426 4.74023Z"

export const RatingStarIcon = ({ size = 14, filled = true, ...props }: IconProps & { filled?: boolean }) =>
  filled ? (
    <svg {...box(size, 14.0002, 14, props)}>
      <path d={STAR_PATH} fill="currentColor" />
    </svg>
  ) : (
    <svg {...box(size, 14.0002, 14, props)}>
      <path d={STAR_OUTLINE_PATH} stroke="currentColor" strokeWidth={(1.5 * 14) / size} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )

export const ParcelIcon = ({ size = 14.2628, ...props }: IconProps) => (
  <svg {...box(size, 13.575, 14.2628, props)} stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3.69365 1.99414L9.88115 5.15539" />
    <path d="M6.09602 0.766471L1.45502 3.13797C1.19627 3.27219 0.979549 3.47518 0.828703 3.72461C0.677857 3.97403 0.598726 4.26023 0.600016 4.55172V9.71097C0.598797 10.0025 0.67804 10.2888 0.829023 10.5382C0.980006 10.7877 1.19688 10.9906 1.45577 11.1247L6.09602 13.4955C6.31012 13.6052 6.54728 13.6625 6.78789 13.6625C7.0285 13.6625 7.26566 13.6052 7.47977 13.4955L12.12 11.1247C12.3788 10.9906 12.5956 10.7876 12.7464 10.5381C12.8973 10.2887 12.9764 10.0025 12.975 9.71097V4.55172C12.9765 4.2602 12.8974 3.97393 12.7465 3.72448C12.5957 3.47502 12.3789 3.27206 12.12 3.13797L7.47977 0.766471C7.26555 0.657052 7.02843 0.6 6.78789 0.6C6.54735 0.6 6.31023 0.657052 6.09602 0.766471Z" />
    <path d="M12.7301 3.69951L6.78707 6.73551L0.844819 3.69951" />
    <path d="M6.7874 6.73584V13.6628" />
    <path d="M9.88115 5.15527V7.33927" />
  </svg>
)

export const CheckShieldIcon = ({ size = 15, ...props }: IconProps) => (
  <svg {...box(size, 15, 15, props)} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5.5 7.47372L6.52083 8.82024C6.55961 8.87386 6.61161 8.91813 6.67251 8.94936C6.73341 8.98059 6.80145 8.99789 6.871 8.99982C6.94054 9.00175 7.00957 8.98825 7.07237 8.96045C7.13517 8.93265 7.18992 8.89135 7.23208 8.83997L10.5 5" />
    <path d="M2.35714 0.999497C2.12981 0.999497 1.9118 1.09081 1.75105 1.25334C1.59031 1.41587 1.5 1.63631 1.5 1.86617V7.06618C1.5 9.84703 5.63371 12.9416 7.03886 13.8609C7.17601 13.9513 7.33624 13.9995 7.5 13.9995C7.66376 13.9995 7.82399 13.9513 7.96114 13.8609C9.36629 12.9416 13.5 9.84703 13.5 7.06618V1.86617C13.5 1.75235 13.4778 1.63966 13.4348 1.53451C13.3917 1.42936 13.3285 1.33382 13.2489 1.25334C13.1694 1.17286 13.0749 1.10902 12.9709 1.06547C12.8669 1.02191 12.7554 0.999497 12.6429 0.999497H2.35714Z" />
  </svg>
)

export const HairlinePlusIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...box(size, 16, 16, props)} stroke="currentColor">
    <path d="M8 0V16" />
    <path d="M0 8H16" />
  </svg>
)

export const HairlineChevronIcon = ({ size = 9.74329, ...props }: IconProps) => (
  <svg {...box(size, 6.08191, 9.74329, props)} stroke="currentColor">
    <path d="M0.334482 0.371647L5.33448 4.87165L0.334482 9.37165" />
  </svg>
)

export const DiscArrowIcon = ({ size = 50, ...props }: IconProps) => (
  <svg {...box(size, 50, 50, props)} stroke="currentColor" strokeLinecap="round">
    <path d="M15.1005 25H34.8995M25.2372 15.3377L34.8995 25L25.2372 34.6623" vectorEffect="non-scaling-stroke" />
  </svg>
)

const DISC_HEART_PATH =
  "M24.9998 35.9375L14.3457 24.8243C13.4102 23.8886 12.7928 22.6821 12.5811 21.3759C12.3695 20.0697 12.5743 18.73 13.1666 17.5467C13.6132 16.6534 14.2656 15.879 15.0702 15.2873C15.8748 14.6957 16.8084 14.3038 17.7942 14.1438C18.78 13.9839 19.7897 14.0605 20.74 14.3675C21.6903 14.6744 22.5541 15.2028 23.2602 15.9091L24.9998 17.6488L26.7393 15.9091C27.4456 15.2028 28.3095 14.6744 29.26 14.3675C30.2105 14.0606 31.2203 13.9839 32.2062 14.1439C33.1922 14.3038 34.126 14.6957 34.9307 15.2873C35.7355 15.879 36.3882 16.6533 36.835 17.5467C37.4264 18.7303 37.6305 20.07 37.4185 21.3761C37.2065 22.6822 36.5892 23.8885 35.6538 24.8243L24.9998 35.9375Z"

export const DiscHeartIcon = ({ size = 50, filled = false, ...props }: IconProps & { filled?: boolean }) => (
  <svg {...box(size, 50, 50, props)}>
    <path d={DISC_HEART_PATH} stroke="currentColor" fill={filled ? "currentColor" : "none"} strokeWidth="2.34375" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const HEART_GLYPH_PATH =
  "M5.44986 1.40632L5.73482 1.41934C6.87105 1.50629 7.93091 2.02098 8.71812 2.85346C9.57053 1.95119 10.7448 1.42242 11.9889 1.40632H12.0003L12.2373 1.41413C14.6727 1.5566 16.6015 3.64326 16.5937 6.19063C16.5937 9.00823 15.1916 11.2473 13.6432 12.8598C12.0939 14.4732 10.3418 15.5192 9.5024 15.9715C9.07029 16.2045 8.57186 16.2348 8.12297 16.0602L7.93384 15.9729C7.09443 15.5205 5.34339 14.4732 3.79429 12.8598C2.34309 11.3482 1.02005 9.28616 0.860166 6.71295L0.843774 6.19063C0.835684 3.56134 2.89018 1.42253 5.43725 1.40632H5.44986Z"

export const HeartGlyphIcon = ({ size = 18, filled = false, ...props }: IconProps & { filled?: boolean }) => (
  <svg {...box(size, 18, 18, props)}>
    <path
      d={HEART_GLYPH_PATH}
      transform="translate(0.44 0.85)"
      stroke="currentColor"
      fill={filled ? "currentColor" : "none"}
      strokeWidth="1.6875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
